import { Controller } from "@hotwired/stimulus"
import { Popover } from "bootstrap"

export default class extends Controller {
  connect() {
    this.popovers = []

    const elements = this.element.querySelectorAll('[data-bs-toggle="popover"]')

    elements.forEach((el) => {
      // Remove native browser tooltip if a title attribute exists.
      // (Bootstrap may also read from title if present, which can cause double UI.)
      if (el.hasAttribute("title")) el.removeAttribute("title")

      const popover = Popover.getOrCreateInstance(el, {
        trigger: "hover focus",
        placement: el.getAttribute("data-bs-placement") || "top",
        container: "body",
        delay: { show: 60, hide: 40 },
        html: false,
      })

      // Avoid popovers lingering when clicking a dot to open a modal.
      el.addEventListener("click", () => popover.hide())

      this.popovers.push(popover)
    })
  }

  disconnect() {
    this.popovers?.forEach((p) => p.dispose())
    this.popovers = []
  }
}
